import deepMerge from 'deepmerge';

import actionsFn from './actions';
import basePalette from './palette';
import buttonsFn from './buttons';
import linksFn from './links';
import baseSpacing from './spacing';
import typographyFn from './typography';
import forms from './forms';
import screenSizes from './screenSizes';
import shadows from './shadows';
import custom from './custom';
import tabsFn from './tabs';

export default (inputTheme = {}) => {
  const palette = inputTheme.palette ? deepMerge(basePalette, inputTheme.palette) : basePalette;
  const typographyBase = typographyFn({ palette });
  const typography = inputTheme.typography
    ? deepMerge(typographyBase, inputTheme.typography)
    : typographyBase;
  const spacing = inputTheme.spacing ? deepMerge(baseSpacing, inputTheme.spacing) : baseSpacing;

  const actions = actionsFn({ palette, typography });
  const buttons = buttonsFn({ palette, spacing, typography });
  const links = linksFn({ palette, typography });
  const tabs = tabsFn({ palette, typography });
  const base = {
    actions,
    custom,
    forms,
    links,
    oaoButtons: buttons,
    palette,
    screenSizes,
    shadows,
    spacing,
    tabs,
    typography,
  };

  const merged = Object.keys(base).reduce(
    (origin, key) => ({
      ...origin,
      [key]: inputTheme[key] ? deepMerge(base[key], inputTheme[key]) : base[key],
    }),
    base,
  );

  merged.name = 'ash';

  return merged;
};
